import React from "react";
import { links } from "../../portfolio.js";
import obj from "./About.js";
import { Button } from "react-bootstrap";
import TemporaryDrawer from "./ResumeButton";
function Common(props) {
  console.log(obj.btn_get_started);
  return (
    <div>
      <section id="header" className="d-flex align-items-center">
        <div className="container-fluid nav_bg">
          <div className="row">
            <div className="col-lg-10 col-md-12 col-sm-12 mx-auto">
              <div className="row">
                <div className="col-md-6 pt-1 pt-lg-0 order-2 order-lg-1 d-flex justify-content-center flex-column">
                  <h3 className="f_color text-center about_me">
                    {props.about[0]}
                  </h3>

                  <h3 className="d_color text-center about_me">
                    {props.about[1]}
                  </h3>

                  <div id="social">
                    <div id="container">
                      <ul style={{ margin: "0" }}>
                        {links.links_data.map((item) => {
                          return (
                            <li key={item.name}>
                              <a href={item.url}>
                                <i className={item.className}></i>
                              </a>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </div>
                  <div
                    className="modal-footer"
                    style={{
                      justifyContent: "center",
                    }}
                  >
                    <TemporaryDrawer />
                    &nbsp;
                    <Button
                      className="btn-get-started main-color"
                      href={props.visit}
                    >
                      {props.btname}
                    </Button>
                  </div>
                </div>
                <div className="col-lg-6 order-1 order-lg-2 header-img">
                  <center>
                    {" "}
                    <img
                      src={props.imgsrc}
                      className="img-fluid "
                      alt=""
                      width="400"
                      height="400"
                      style={{ borderRadius: "50%" }}
                    />
                  </center>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Common;
